<div class="main">
  <div class="background-items">
    <svg
      class="bg"
      width="261"
      height="261"
      viewBox="0 0 261 261"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="130.5" cy="130.5" r="130.5" fill="#040404" />
      <circle
        cx="130.5"
        cy="130.5"
        r="130.5"
        fill="url(#paint0_linear_308_5349)"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_308_5349"
          x1="130.5"
          y1="0"
          x2="130.5"
          y2="261"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-opacity="0" />
          <stop offset="1" stop-color="#FFAA00" />
        </linearGradient>
      </defs>
    </svg>
    <svg
      class="middle"
      width="249"
      height="249"
      viewBox="0 0 249 249"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="124.5"
        cy="124.5"
        r="124.5"
        fill="white"
        fill-opacity="0.02"
      />
    </svg>
    <img class="image" src="assets/images/core/tf2-logo-hex.png" />
  </div>
  @if (upgraderService.chance() > 1) {
  <circle-progress
    @fadeInAnimation
    class="circle"
    [class.over]="!upgraderService.isUnder()"
    [percent]="(upgraderService.chance() / 100) * 100"
    [radius]="130"
    [outerStrokeColor]="circleColor()"
    [showInnerStroke]="false"
    [animation]="false"
    [showImage]="false"
    [showTitle]="false"
    [showSubtitle]="false"
    [showUnits]="false"
  ></circle-progress>
  }
  <div class="content" [class.rolling]="upgraderService.isProcessing()">
    <div class="title">CHANCE</div>
    <div class="chance">{{ upgraderService.chance().toFixed(2) }}%</div>
  </div>
  <div class="ball" #ball>
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="7" fill="#FFAA00" />
      <circle cx="7" cy="7" r="5" fill="#C68400" />
    </svg>
  </div>
</div>
<div class="buttons">
  <div
    class="upgrade-direction"
    [class.not-selected]="!upgraderService.isUnder()"
    (click)="changeUnderOverState(true)"
  >
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7659 9.36867L9.52405 6.39675C9.4617 6.35306 9.40124 6.32998 9.33398 6.32998C9.18804 6.32998 9.0484 6.44084 9.0484 6.65271V8.46432H0.8776C0.658619 8.46432 0.486858 8.64667 0.486858 8.86565V10.4351C0.486858 10.6541 0.658619 10.8474 0.8776 10.8474H9.0484V12.6484C9.0484 12.8603 9.18817 12.9658 9.33411 12.9658C9.33416 12.9658 9.33018 12.9658 9.33018 12.9658C9.39744 12.9658 9.46399 12.9454 9.52635 12.9017L13.767 9.93139C13.8647 9.86298 13.9202 9.76086 13.9202 9.65005C13.9202 9.53923 13.8636 9.43703 13.7659 9.36867Z"
        fill="white"
      />
      <path
        d="M13.7659 9.36867L9.52405 6.39675C9.4617 6.35306 9.40124 6.32998 9.33398 6.32998C9.18804 6.32998 9.0484 6.44084 9.0484 6.65271V8.46432H0.8776C0.658619 8.46432 0.486858 8.64667 0.486858 8.86565V10.4351C0.486858 10.6541 0.658619 10.8474 0.8776 10.8474H9.0484V12.6484C9.0484 12.8603 9.18817 12.9658 9.33411 12.9658C9.33416 12.9658 9.33018 12.9658 9.33018 12.9658C9.39744 12.9658 9.46399 12.9454 9.52635 12.9017L13.767 9.93139C13.8647 9.86298 13.9202 9.76086 13.9202 9.65005C13.9202 9.53923 13.8636 9.43703 13.7659 9.36867Z"
        fill="url(#paint0_linear_305_3638)"
      />
      <path
        d="M4.59292 6.71503C4.6848 6.71503 4.77549 6.67275 4.82995 6.59896C4.87139 6.54287 4.90003 6.47138 4.90003 6.3923V4.58069H13.0413C13.2603 4.58069 13.4174 4.39834 13.4174 4.17936V2.60995C13.4174 2.39096 13.2603 2.19762 13.0413 2.19762H4.90003V0.39661C4.90003 0.184734 4.74548 0.0738754 4.59954 0.0738754C4.53228 0.0738754 4.46034 0.0969563 4.39799 0.140647L0.154549 3.1123C0.0568857 3.18075 0 3.28353 0 3.39434C0 3.50516 0.0556059 3.60794 0.153269 3.67639L4.39499 6.6483C4.45734 6.69195 4.52566 6.71503 4.59292 6.71503Z"
        fill="white"
      />
      <path
        d="M4.59292 6.71503C4.6848 6.71503 4.77549 6.67275 4.82995 6.59896C4.87139 6.54287 4.90003 6.47138 4.90003 6.3923V4.58069H13.0413C13.2603 4.58069 13.4174 4.39834 13.4174 4.17936V2.60995C13.4174 2.39096 13.2603 2.19762 13.0413 2.19762H4.90003V0.39661C4.90003 0.184734 4.74548 0.0738754 4.59954 0.0738754C4.53228 0.0738754 4.46034 0.0969563 4.39799 0.140647L0.154549 3.1123C0.0568857 3.18075 0 3.28353 0 3.39434C0 3.50516 0.0556059 3.60794 0.153269 3.67639L4.39499 6.6483C4.45734 6.69195 4.52566 6.71503 4.59292 6.71503Z"
        fill="url(#paint1_linear_305_3638)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_305_3638"
          x1="0.486858"
          y1="13.6079"
          x2="6.18622"
          y2="4.94649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8D24" />
          <stop offset="1" stop-color="#FFC700" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_305_3638"
          x1="-1.22184e-07"
          y1="7.35772"
          x2="5.70849"
          y2="-1.30026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8D24" />
          <stop offset="1" stop-color="#FFC700" />
        </linearGradient>
      </defs>
    </svg>
    UNDER
  </div>
  <button
    class="upgrade-button"
    (click)="roll()"
    [class.disabled]="
      !upgraderService.isValid() || upgraderService.isProcessing()
    "
  >
    {{ upgraderService.isProcessing() ? "UPGRADING..." : "UPGRADE" }}
  </button>
  <div
    class="upgrade-direction"
    [class.not-selected]="upgraderService.isUnder()"
    (click)="changeUnderOverState(false)"
  >
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7659 9.36867L9.52405 6.39675C9.4617 6.35306 9.40124 6.32998 9.33398 6.32998C9.18804 6.32998 9.0484 6.44084 9.0484 6.65271V8.46432H0.8776C0.658619 8.46432 0.486858 8.64667 0.486858 8.86565V10.4351C0.486858 10.6541 0.658619 10.8474 0.8776 10.8474H9.0484V12.6484C9.0484 12.8603 9.18817 12.9658 9.33411 12.9658C9.33416 12.9658 9.33018 12.9658 9.33018 12.9658C9.39744 12.9658 9.46399 12.9454 9.52635 12.9017L13.767 9.93139C13.8647 9.86298 13.9202 9.76086 13.9202 9.65005C13.9202 9.53923 13.8636 9.43703 13.7659 9.36867Z"
        fill="white"
      />
      <path
        d="M13.7659 9.36867L9.52405 6.39675C9.4617 6.35306 9.40124 6.32998 9.33398 6.32998C9.18804 6.32998 9.0484 6.44084 9.0484 6.65271V8.46432H0.8776C0.658619 8.46432 0.486858 8.64667 0.486858 8.86565V10.4351C0.486858 10.6541 0.658619 10.8474 0.8776 10.8474H9.0484V12.6484C9.0484 12.8603 9.18817 12.9658 9.33411 12.9658C9.33416 12.9658 9.33018 12.9658 9.33018 12.9658C9.39744 12.9658 9.46399 12.9454 9.52635 12.9017L13.767 9.93139C13.8647 9.86298 13.9202 9.76086 13.9202 9.65005C13.9202 9.53923 13.8636 9.43703 13.7659 9.36867Z"
        fill="url(#paint0_linear_305_3638)"
      />
      <path
        d="M4.59292 6.71503C4.6848 6.71503 4.77549 6.67275 4.82995 6.59896C4.87139 6.54287 4.90003 6.47138 4.90003 6.3923V4.58069H13.0413C13.2603 4.58069 13.4174 4.39834 13.4174 4.17936V2.60995C13.4174 2.39096 13.2603 2.19762 13.0413 2.19762H4.90003V0.39661C4.90003 0.184734 4.74548 0.0738754 4.59954 0.0738754C4.53228 0.0738754 4.46034 0.0969563 4.39799 0.140647L0.154549 3.1123C0.0568857 3.18075 0 3.28353 0 3.39434C0 3.50516 0.0556059 3.60794 0.153269 3.67639L4.39499 6.6483C4.45734 6.69195 4.52566 6.71503 4.59292 6.71503Z"
        fill="white"
      />
      <path
        d="M4.59292 6.71503C4.6848 6.71503 4.77549 6.67275 4.82995 6.59896C4.87139 6.54287 4.90003 6.47138 4.90003 6.3923V4.58069H13.0413C13.2603 4.58069 13.4174 4.39834 13.4174 4.17936V2.60995C13.4174 2.39096 13.2603 2.19762 13.0413 2.19762H4.90003V0.39661C4.90003 0.184734 4.74548 0.0738754 4.59954 0.0738754C4.53228 0.0738754 4.46034 0.0969563 4.39799 0.140647L0.154549 3.1123C0.0568857 3.18075 0 3.28353 0 3.39434C0 3.50516 0.0556059 3.60794 0.153269 3.67639L4.39499 6.6483C4.45734 6.69195 4.52566 6.71503 4.59292 6.71503Z"
        fill="url(#paint1_linear_305_3638)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_305_3638"
          x1="0.486858"
          y1="13.6079"
          x2="6.18622"
          y2="4.94649"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8D24" />
          <stop offset="1" stop-color="#FFC700" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_305_3638"
          x1="-1.22184e-07"
          y1="7.35772"
          x2="5.70849"
          y2="-1.30026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF8D24" />
          <stop offset="1" stop-color="#FFC700" />
        </linearGradient>
      </defs>
    </svg>
    OVER
  </div>
</div>
